// removed by extract-text-webpack-plugin
module.exports = {"group":"TElesylozdEQ_225OCY9H","groupTitle":"_3i3grzDR7Uw79IjMWNbfqe","sdkPart":"_2Hvp6hk1pPrt_DQkqGeetF","title":"pTimg0lWENA5NIJVOGKCk","time":"_222wi9kFTD7qZ4IQNYGms8","desc":"m12qmBfvdY33zOWdxpO-m","sdkInfo":"_1mVi2WEqArQZ37JmV84LuH","downloadPart":"_2tK3KaztyI1USEonecGI0Z","button":"_3ZpVtJyGGp7LCwkbR5Dnhp","toggleMore":"_12rflEuiwoYDY6at7HcVjS","radioBox":"_3_Mz9zP1-VDoR7QaOR6pRC","radio":"_4J5JPNyLQDtoP_sLCCBcI"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/SDKDownload/index.less
// module id = 748
// module chunks = 0